import { apiSlice } from "./apiSlice";
import domain from "../util/domain";
const ADDSPROMOS_URL = `${domain}/api/addspromos`;

export const addsPromosApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllAddsPromos: builder.query({
      query: () => ({
        url: `${ADDSPROMOS_URL}/alladdspromos`,
      }),
      providesTags: ["AddsPromos"],
    }),
    updateAddsPromos: builder.mutation({
      query: (addsPromosData) => ({
        url: `${ADDSPROMOS_URL}/${addsPromosData.id}`,
        method: "PUT",
        body: addsPromosData,
      }),
      invalidatesTags: ["AddsPromos"],
    }),
    newAddsPromos: builder.mutation({
      query: (addsPromosData) => ({
        url: `${ADDSPROMOS_URL}`,
        method: "POST",
        body: addsPromosData,
      }),
      invalidatesTags: ["AddsPromos"],
    }),
  }),
});

export const {
  useGetAllAddsPromosQuery,
  useUpdateAddsPromosMutation,
  useNewAddsPromosMutation,
} = addsPromosApiSlice;
